import React from 'react';
import { CreditasIconPrincipal } from '@creditas/logos-react';

const Logo = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <CreditasIconPrincipal width={32} height={32} {...props} />
);

export { Logo };
